export function generateProductSlug(text: string): string {
    return text
        .toLowerCase() // Convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // Remove invalid characters
        .trim() // Trim whitespace
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/--+/g, '-'); // Replace multiple hyphens with a single one
}